<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg8 sm12 xs12>
        <v-card>
          <v-card-title>
            <h3>Ubah Peminjaman Ruangan</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-snackbar
            v-model="show"
            multi-line="true"
            top=true
            :color="snackbarColor"
          >
            {{ notifMsg }}
            <v-btn
              :color="buttonSnackbarColor"
              flat
              @click="show = false"
            >
              Tutup
            </v-btn>
          </v-snackbar>
          <v-card-text>
            <v-form class="px-3">
              <v-text-field label="Nama PIC" v-model="form.namaPIC"></v-text-field>
              <v-select
                name="jenis_peminjaman"
                label="Jenis Peminjaman"
                :items="peminjaman"
                v-model="form.idJenisPenggunaanRuangan">
              </v-select>
              <v-select
                name="nama_gedung"
                label="Gedung"
                :items="gedung"
                @change="onGedung"
                v-model="form.idGedung"
              >
              </v-select>
              <v-select name="ruangan"
                        label="Ruangan"
                        :items="ruangan"
                        v-model="form.idRuangan"
                        :onChange="onMaxRuangan(form.idRuangan)">
              </v-select>
              Maximum Kapasitas Ruangan: {{maxRuangan}}
              <v-layout row wrap>
                <v-flex xs11 sm5>
                  <v-menu
                    ref="menu"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date1"
                        label="Tanggal Mulai"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date1" no-title scrollable :min="minDate">
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary" 
                        style="min-width:100px;"
                        @click="menu1= false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="$refs.menu.save(date);menu1=false"
                      >
                      OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="menu"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date2"
                        label="Tanggal Selesai"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date2" no-title scrollable :min="minDate">
                      <div class="flex-grow-1"></div>
                      <v-spacer></v-spacer>
                      <v-btn 
                        text 
                        color="primary"
                        style="min-width:100px;" 
                        @click="menu2 = false"
                      >
                      Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="$refs.menu.save(date);menu2=false"
                      >
                      OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs11 sm5>
                  <v-menu
                    ref="menu"
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time1"
                        label="Waktu Mulai"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker v-if="menu3" v-model="time1" :min="minTime" format="24h" full-width >
                      <v-spacer></v-spacer>
                      <v-btn  
                        text 
                        color="primary"
                        style="min-width:100px;" 
                        @click="menu3= false"
                      >
                      Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="$refs.menu.save(date);menu3=false"
                      >
                      OK
                      </v-btn>
                    </v-time-picker>
                  </v-menu>
                  <v-menu
                    ref="menu"
                    v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time2"
                        label="Waktu Selesai"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker v-if="menu4" v-model="time2" :min="minTime" format="24h" full-width>
                      <v-spacer></v-spacer>
                      <v-btn 
                        text 
                        color="primary" 
                        style="min-width:100px;"
                        @click="menu4= false"
                      >
                      Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        style="min-width:100px;"
                        @click="$refs.menu.save(date);menu4=false"
                      >
                      OK
                      </v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-card-actions class="justify-center">
                <v-btn 
                  class="btn-simpan" 
                  color="blue"
                  dark
                  style="width:120px;"
                  @click="onSubmit"
                >
                  <v-icon left>
                    fa fa-check
                  </v-icon> 
                  Simpan
                </v-btn>
                <v-btn
                  class="btn-batal" 
                  color="red"
                  dark
                  @click="onBatal"
                  style="width:120px;"
                >
                  <v-icon left>
                    fa fa-times
                  </v-icon> 
                  Batal
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {base} from "../../setup-axios"
import {createJWT} from "../../store/module/helper";
import { mapGetters,  mapActions} from 'vuex'

export default {
  name: "Edit",
  data() {
    return {
      multiple: [
        {
          text: "Ya",
          value: 1
        },
        {
          text: "Tidak",
          value: 2
        }
      ],
      peminjaman: [],
      ruangan: [],
      gedung: [],
      form:{},
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      time1: null,
      time2: null,
      show: false,
      snackbarColor: "green",
      buttonSnackbarColor: "pink",
      notifMsg: "",
      maxRuangan: "",
    }
  },
  // beforeCreate(){
  //   var thisVM = this
  //   base.get("penggunaanRuangan/"+  this.$route.params.id,
  //          {
  //            headers: {F
  //              Authorization: createJWT()
  //            }
  //          }).then(
  //     resp => {
  //       if(resp.data.result[0].jenisPenggunaanRuangan !== "Kuliah Rutin"){
  //         thisVM.$router.push("/404")
  //       }
  //     })
  // },
  created(){
    base.get("penggunaanRuangan/"+  this.$route.params.id,
           {
             headers: {
               Authorization: createJWT()
             }
           }).then(
      resp => {
        console.log(resp)
           this.form = resp.data.result[0]
           this.onGedung()
           this.date1 = resp.data.result[0].mulai.split(" ")[0]
           this.time1 = resp.data.result[0].mulai.split(" ")[1]
           this.date2 = resp.data.result[0].selesai.split(" ")[0]
           this.time2 = resp.data.result[0].selesai.split(" ")[1]
      })
    base.get("jenisPenggunaanRuangan",
           {
             headers: {
               Authorization: createJWT()
             }
           }
    ).then((resp) => {
      for(var i=0; i < resp.data.result.length;i++){
        this.peminjaman.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
      }
    })

    base.get("gedung/dropdown",
           {
             headers: {
               Authorization: createJWT()
             }
           }
    ).then((resp) => {
      for(var i=0; i < resp.data.result.length;i++){
        this.gedung.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
      }
    })
  },
  computed:{
    ...mapGetters(["snackbar"]),
    minDate(){
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.setMinDate(today);
    },
    minTime(){
      const today = new Date()
      return this.setMinTime(today);
    }
  },
  methods: {
    ...mapActions(["fetchSnackbar", "fetchMsgSnackbar", "fetchPathSnackbar"]),
    onBatal() {
      this.$router.push("/peminjaman/peminjaman")
    },
    setMinDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join('-');
    },
    setMinTime(date){
      var pickedDate = Date.parse(this.date1.replace(/-/g, " "));

      if(pickedDate > date){
        return "00:00"
      }

      else {
        return date.getHours() + ":" + date.getMinutes()
      }
    },
    onMaxRuangan(id){
      base.get("/ruangan/"+id,
           {
             headers: {
               Authorization: createJWT()
             }
           }).then(resp => {
        this.maxRuangan = resp.data.resultById.kapasitasMaksimal
      })
    },
    onValidateTime(mulai, selesai){
      var dateMulai = new Date(mulai);
      var dateSelesai = new Date(selesai)
      console.log(dateMulai)
      console.log(dateSelesai)
      console.log(dateMulai < dateSelesai)
      return (dateMulai < dateSelesai)

    },
    formatDate(date) {
      if (!date) return null

      console.log(date)
      const [year, month, day] = date.split("-")
      console.log('year')
      return `${day}-${month}-${year}`
    },
    onGedung() {
      base.get("ruangan/dropdown/byGedung/" + this.form.idGedung,
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        for(var i=0; i < resp.data.result.length;i++){
          this.ruangan.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
        }
      })
        .catch(function(error) {
          console.log('ERROR : ', error)
          console.log('isi dari error', error.response)
        })
    },
    onSubmit(){
        this.form.mulai = this.formatDate(this.date1) + " " + this.time1
        this.form.selesai = this.formatDate(this.date2) + " " + this.time2
        console.log(this.form.mulai + " "+ this.form.selesai)
        let validateTime = this.onValidateTime(this.date1+" "+this.time1, this.date2 + " " + this.time2)
        console.log(this.form.mulai+ " " + this.form.selesai)
        let thisVM = this
    
        if(validateTime){
          base.put( `penggunaanRuangan/${this.form.id}`, this.form,
           {
             headers: {
               Authorization: createJWT()
             }
           }
          ).then((resp) => {
            console.log('Success');
            console.log(resp.data);
            if(resp.data.message == "Duplikat Data"){
              thisVM.show = true
              thisVM.notifMsg = 'Kode Ruangan Sudah Ada'
              thisVM.snackbarColor = "red"
              thisVM.buttonSnackbarColor = "black"
            }
            if(resp.data.status !== 200){
              console.log('ERROR : ', resp)
              console.log('isi dari error', resp.data)
              thisVM.show = true
              if(resp.data.status == 409){
                thisVM.notifMsg = resp.data.message
                thisVM.snackbarColor = "red"
                thisVM.buttonSnackbarColor = "black"
              }

              if(resp.data.status == 417){
                thisVM.notifMsg = resp.data.message
                thisVM.snackbarColor = "red"
                thisVM.buttonSnackbarColor = "black"
              }
            }
            else {
              thisVM.fetchSnackbar(true, 'Berhasil Mengubah data', 'peminjaman')
              thisVM.fetchMsgSnackbar("Berhasil Mengubah Data")
              thisVM.fetchPathSnackbar("peminjaman")
              thisVM.$router.push('/peminjaman/peminjaman')
            }
          }).catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            thisVM.show = true
            thisVM.notifMsg = 'Gagal Memasukan data'
            thisVM.snackbarColor = "red"
            thisVM.buttonSnackbarColor = "black"
          })
        } else{
            this.show = true
            this.notifMsg = 'Terjadi Kesalahan Pada Input Waktu Atau Tanggal'
            this.snackbarColor = "red"
            this.buttonSnackbarColor = "black"
        }
    }
  }
}
</script>

<style scoped>
</style>